<template lang='pug'>
v-container(fluid).qualify-conversation-tab
  v-snackbar(:value='qualifyConversationError' color='error')
    div {{ error.service }} {{ error.message }}
  v-snackbar(:value='qualifyConversationSuccess' color='success')
    div {{ qualifyConversationMessage }}

  liondesk-dialog(
    dialog-title='Add note for qualify'
    :value='isOpenModalAddNote'
    :disable-ok-button='!noteQualifyTextValid'
    ok-button-text='Add note'
    cancel-button-text='Cancel'
    @click:cancel='cancelAddNote()'
    @click:ok='addNote()'
  )
    template(slot='body')
      v-label Note:
      v-textarea(
        v-if='renderTextArea'
        v-model='noteQualifyTextInput'
        :rules='qualifyTextAreaRules'
        @update:error='noteQualifyInputError'
      )
  liondesk-dialog(
    dialog-title='STOP QUALIFY CONVERSATION'
    :value='isOpenStopQualifyModal'
    ok-button-text='Stop'
    cancel-button-text='Cancel'
    dialog-body='You are stopping this Qualify conversation, you can resume again whenever you need to.'
    @click:cancel='closeStopConversationModal()'
    @click:ok='stopConversation()'
  )
  liondesk-dialog(
    dialog-title='RESUME QUALIFY CONVERSATION'
    :value='isOpenAddCommentsModal'
    ok-button-text='Resume'
    cancel-button-text='Cancel'
    :disable-ok-button='!commentQualifyTextValid'
    @click:cancel='cancelResumeConversation()'
    @click:ok='startConversation()'
  )
    template(slot='body')
      v-layout.mb-4
        v-label You are resuming this Qualify conversation - please tell the Qualify Agent why you are restarting.
      v-label Comments:
      v-textarea(
        v-if='renderTextArea'
        v-model='commentQualifyInputText'
        :rules='qualifyTextAreaRules'
        @update:error='commentQualifyInputError'
      )
  v-layout(row fill-height align-center)
    v-flex.grow 
      span.theme--light.v-label Qualify conversation
    v-flex.shrink.pr-1(v-if='isDenied')  
      v-label Qualify is unavailable. Contact has opted out of SMS.
    v-flex.shrink(v-else)
      v-btn(
        small
        :input-value='isLeadClaimed'
        :color='isLeadClaimed ? "primary" : ""'
        @click='toggleQualifyChange'
      ) {{ getToggleQualifyText }}
      v-btn.primary(small :disabled="isLeadClaimed" @click='openModalAddNote()') ADD NOTE
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import LiondeskDialog from '@/Core/components/LiondeskDialog';
import TitleBar from '@/Core/components/TitleBar';
const { mapActions: mapQualifyConversationsActions, mapState: mapQualifyConversationsState } =
  createNamespacedHelpers('qualify');
const { mapActions: mapConversationsActions, mapState: mapConversationsState } =
  createNamespacedHelpers('conversations');
export default {
  components: {
    LiondeskDialog,
    TitleBar,
  },
  mounted() {
    this.reInitialize();
  },
  unmounted() {
    this.contactsOptInStatuses = [];
  },
  data() {
    return {
      renderTextArea: true,
      selectedQualifyValue: true,
      isOpenModalAddNote: false,
      noteQualifyTextInput: '',
      noteQualifyTextValid: false,
      qualifyTextAreaRules: [
        value => !!value || 'Required.',
        value => (value && value.length >= 10) || 'Min 10 characters',
      ],
      commentQualifyInputText: '',
      commentQualifyTextValid: false,
      isOpenStopQualifyModal: false,
      isOpenAddCommentsModal: false,
      cancelActionFlag: false,
    };
  },
  watch: {
    '$route': 'reInitialize'
  },
  computed: {
    ...mapQualifyConversationsState([
      'isLeadClaimed',
      'loading',
      'error',
      'qualifyConversationError',
      'qualifyConversationMessage',
      'qualifyConversationSuccess',
    ]),
    getToggleQualifyText() {
      if (this.isLeadClaimed) {
        return 'Resume Conversation';
      }
      return 'Stop Conversation';
    },
    ...mapConversationsState([
      'contactsOptInStatuses'
    ]),
    isDenied() {
      if (this.contactsOptInStatuses.length) {
        return this.contactsOptInStatuses[this.contactsOptInStatuses.length - 1].status === 'denied';
      }
    }
  },
  methods: {
    ...mapConversationsActions(['checkContactsOptInStatuses']),
    ...mapQualifyConversationsActions([
      'addNoteQualify',
      'stopQualifyConversation',
      'startQualifyConversation',
    ]),
    reInitialize() {
      this.checkContactsOptInStatuses([Number(this.$route.params.id)])
    },
    reRenderTextAreas() {
      this.renderTextArea = false;
      this.$nextTick(() => {
        this.renderTextArea = true;
      });
    },
    openModalAddNote() {
      this.isOpenModalAddNote = !this.isOpenModalAddNote;
    },
    clearNoteTextArea() {
      this.noteQualifyTextInput = '';
      this.noteQualifyTextValid = false;
      this.reRenderTextAreas();
    },
    cancelAddNote() {
      this.openModalAddNote();
      this.clearNoteTextArea();
    },
    noteQualifyInputError(value) {
      this.noteQualifyTextValid = !value;
    },
    commentQualifyInputError(value) {
      this.commentQualifyTextValid = !value;
    },
    async addNote() {
      this.openModalAddNote();
      await this.addNoteQualify(this.noteQualifyTextInput.slice());
      this.clearNoteTextArea();
      this.$emit("refresh");
    },
    closeStopConversationModal() {
      this.isOpenStopQualifyModal = false;
    },
    closeAddCommentsQualifyModal() {
      this.isOpenAddCommentsModal = false;
    },
    clearCommentTextArea() {
      this.commentQualifyInputText = '';
      this.commentQualifyTextValid = false;
      this.reRenderTextAreas();
    },
    cancelResumeConversation() {
      this.closeAddCommentsQualifyModal();
      this.clearCommentTextArea();
    },
    stopConversation() {
      this.closeStopConversationModal();
      this.stopQualifyConversation();
    },
    startConversation() {
      this.closeAddCommentsQualifyModal();
      this.startQualifyConversation(this.commentQualifyInputText.slice());
      this.clearCommentTextArea();
    },
    toggleQualifyChange() {
      if (this.isLeadClaimed) {
        this.isOpenAddCommentsModal = true;
      } else {
        this.isOpenStopQualifyModal = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.qualify-conversation-tab {
  border: 1px none black;
  border-style: none solid none solid;
}

.container.fluid {
  height: 48px;
  border-bottom: 4px solid orange !important;
}

span.pr-2 {
  font-size: 14px;
}

span.theme--light.v-label {
  font-size: 16px;
}

.v-card__title.c-title {
  --tag-color: none !important;
  padding: 16px !important;
}
</style>
<style lang="scss">

</style>
